import { Workorder } from './Workorder'
import { Id_floor, Id_workorder, Id_category, Id_workorder_category, Id_workorder_asset, Id_building } from '../api/Identifiers'
import { Category, CategoryCollection } from '../Categories';
import { Rectangle } from '../Rectangle';
import { exists } from '../utils';
import { Point } from '../Point';

function uniq(array: string[]): string[] {
    var seen: { [key: string]: any } = {};
    return array.filter((item: any) => {
        return seen.hasOwnProperty(item) ? false : (seen[item] = true);
    });

}

export class WorkordersCollection {
    private _workorders_cache: Workorder[] = null;
    private _workorders: any = {}
    private _categories: Id_workorder_category[] = null;

    private contructor() { }


    public get categories(): Id_workorder_category[] {
        if (this._categories == null) {
            this._categories = []
            let temp: Set<Id_workorder_category> = new Set<Id_workorder_category>();
            this.workorders.forEach((wo: Workorder) => {
                temp.add(Id_workorder_category.wrap(wo.category))
            })
            this._categories = Array.from(temp);//new CategoryCollection();//..ca.workorders.length;}
        }
        return this._categories;
    }
    public get workorders(): Workorder[] {
        if (this._workorders_cache === null) {
            this._workorders_cache = []
            Object.keys(this._workorders).forEach((key: string) => {
                if (this._workorders[key]) {
                    this._workorders_cache.push(this._workorders[key]);
                }
            });
        }
        return this._workorders_cache;
    }
    public get count(): number {
        return this.workorders.length;
    }

    public get ids(): Id_workorder[] {
        let r: Id_workorder[] = [];
        this.workorders.forEach((wo: Workorder) => {
            r.push(wo.id);
        });
        return r;
    }

    private static build(workorders: Workorder[]): WorkordersCollection {
        let r: WorkordersCollection = new WorkordersCollection()
        r.add(workorders);
        return r;
    }

    public toJSON(): any[] {
        let r: any[] = []
        this.workorders.forEach((workorder: Workorder) => {
            r.push(workorder.toJSON())
        });
        return r;
    }


    public get_for_floor(id_floor: Id_floor): WorkordersCollection {
        let filtered_workorders: Workorder[] = this.workorders.filter((workorder: Workorder) => {
            if (!exists(workorder)) {
                return false;
            }
            if (!exists(id_floor)) {
                return false;
            }
            return id_floor.equals(workorder.id_floor);
        })
        return WorkordersCollection.build(filtered_workorders);
    }

    public get active_workorders(): WorkordersCollection {
        let filtered_workorders: Workorder[] = this.workorders.filter((workorder: Workorder) => {
            return workorder.active;
        })
        return WorkordersCollection.build(filtered_workorders);
    }

    public get_workorder(id_workorder: Id_workorder): Workorder {
        let r: Workorder = this._workorders[id_workorder.toString()];
        if (!r) {
            r = null;
        }
        return r;
    }

    public get_workorder_from_multi_asset_id(id_workorder_asset: Id_workorder_asset): Workorder {
        let retVal:Workorder = null;
        let filtered_workorders: Workorder[] = this._workorders.filter((workorder: Workorder) => {
            return workorder.is_multi_asset;
        })
        let wo:Workorder =null;
        for (wo of filtered_workorders){
            if (wo){
                for (let i = 0; i < wo.asset_info.length; i++){
                    if (wo.asset_info[i].id_workorder_asset == id_workorder_asset){
                        retVal= wo;
                        break;
                    }
                }
                
            }
        }
        return retVal;
    }


    public static get empty_collection(): WorkordersCollection { return WorkordersCollection.build([]); }

    public static build_from_raw(raw_workorders: any): WorkordersCollection {

        let workorders: Workorder[] = [];
        raw_workorders.forEach((raw_workorder: any) => {
            workorders.push(Workorder.build_from_raw(raw_workorder))
        })
        return WorkordersCollection.build(workorders);
    }

    public add_raw(raw_workorders: any[]): void {
        raw_workorders.forEach((raw_workorder: any) => {
            this.add([Workorder.build_from_raw(raw_workorder)]);
        })
    }

    public add(workorders: Workorder[]): void {
        workorders.forEach((wo: Workorder) => {
            if (wo) {
                this._workorders[wo.id.toString()] = wo;
                this._workorders_cache = null;
                this._categories = null;
            }
        });
    }

    public equals(rhs: WorkordersCollection): boolean {
        let r: boolean = false;
        if (typeof (rhs) === typeof (this)) {
            r = this === rhs;
            console.debug("equals() -> " + r);
            // need to do a deep compare?
        }
        return r;
    }


    public translate_workorders(drawing_p1p2: Rectangle, id_floor: Id_floor, p0: Point, nudge_overlapping: boolean) {
        if (exists(drawing_p1p2)) {
            if (exists(id_floor)) {
                this.workorders.forEach((wo: Workorder) => {
                    if (wo.id_floor.equals(id_floor)) {
                        wo.translate(drawing_p1p2, p0);
                    }
                })
                if (nudge_overlapping) {
                    // decluster
                    console.debug(`AWH TODO - Decluster not implemented for work orders`)
                }
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/ts/workorders/WorkordersCollection.ts